import createInstance from "./interceptors";

const API_URL = process.env.VUE_APP_API_BASE_URL + "/api";

class Student {
  getStatus() {
    const instance = createInstance();

    return instance.get(API_URL + "/status").then((response) => {
      return response.data;
    });
  }
}

export default new Student();
